export default "__VITE_PUBLIC_ASSET__b8f2cc9d__"